import React from 'react';
import { Link } from 'react-router-dom';
import './WordCollections.css';

const WordCollections = () => {
  const collections = [
    {
      title: 'SAT Vocabulary',
      collection: 'sat',
      link: '/collections/sat'
    },
    {
      title: 'TOEFL Vocabulary',
      collection: 'toefl',
      link: '/collections/toefl'
    },
    {
      title: 'Oxford 5000',
      collection: 'oxford',
      link: '/collections/oxford'
    },
    {
      title: 'Elementary school words',
      collection: 'elementary',
      link: '/collections/elementary'
    },
    {
      title: 'Middle school words',
      collection: 'middle',
      link: '/collections/middle'
    },
    {
      title: 'High school words',
      collection: 'high',
      link: '/collections/high'
    }
  ];

  return (
    <div className="word-collections">
      <div className="collections-header">
        <span className="collections-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
            <path d="M7 7h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
          </svg>
        </span>
        <h2 className="collections-title">Word collections</h2>
      </div>

      <div className="collections-grid">
        {collections.map((collection, index) => (
          <Link
            key={index}
            to={collection.link}
            className="collection-card"
            data-collection={collection.collection}
          >
            <h3 className="collection-title">{collection.title}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default WordCollections; 